import { render, staticRenderFns } from "./deviceData.vue?vue&type=template&id=083e942d&scoped=true"
import script from "./deviceData.vue?vue&type=script&lang=js"
export * from "./deviceData.vue?vue&type=script&lang=js"
import style0 from "./deviceData.vue?vue&type=style&index=0&id=083e942d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e942d",
  null
  
)

export default component.exports